export const patientVitalsData = {
  height: '94.00',
  priority: '1',
};
